"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var framer_motion_1 = require("framer-motion");
var helpers_1 = require("../helpers");
var react_1 = require("react");
var fi_1 = require("react-icons/fi");
function AccordionItem(props) {
    var _a = __read((0, react_1.useState)(false), 2), accordionOpen = _a[0], setAccordionOpen = _a[1];
    return ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { animate: accordionOpen ? "open" : "closed", className: "  border-b-[2px] border-b-slate-300 p-1", children: [(0, jsx_runtime_1.jsxs)("button", { className: "flex w-full cursor-pointer flex-row items-center justify-between py-6", onClick: function () {
                    setAccordionOpen(function (prev) { return !prev; });
                }, children: [(0, jsx_runtime_1.jsx)(framer_motion_1.motion.span, { variants: {
                            open: {
                                color: "rgba(3, 6, 23, 0)",
                            },
                            closed: {
                                color: "rgba(3, 6, 23, 1)",
                            },
                        }, className: "bg-gradient-to-r from-royal-purple to-rgb-blue bg-clip-text text-left text-md font-medium ", children: props.header }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.span, { variants: {
                            open: {
                                rotate: "180deg",
                                color: "rgb(124 58 237)",
                            },
                            closed: {
                                rotate: "0deg",
                                color: "#030617",
                            },
                        }, children: (0, jsx_runtime_1.jsx)(fi_1.FiChevronDown, { className: "text-2xl" }) })] }), accordionOpen && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div
            // className={`${topiaBlockClassnames(blok)}`}
            , { 
                // className={`${topiaBlockClassnames(blok)}`}
                className: "text-slate-60 topia-sb-rich-text overflow-hidden", initial: false, animate: {
                    height: open ? "fit-content" : "0px",
                    marginBottom: open ? "20px" : "0px",
                }, dangerouslySetInnerHTML: {
                    __html: (0, helpers_1.topiaRichText)(props.detail),
                } }))] }));
}
exports.AccordionItem = AccordionItem;
